import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {SidebarContentWatchingCenterComponent} from "@components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-watching-center/sidebar-content-watching-center.component";
import {MyWebDeskService} from "@components/my-web-desk/my-web-desk.service";
import {TaskService} from "@components/my-web-desk/new-task-modal/task.service";

@Component({
    selector: 'app-sidebar-content',
    templateUrl: './sidebar-content.component.html',
    styleUrls: ['./sidebar-content.component.css']
})
export class SidebarContentComponent implements OnInit, AfterViewInit {


    activeMenu = 'notification';
    totalTasksForValidation: number = 0;
    @ViewChild(SidebarContentWatchingCenterComponent) childWatchingCenter: SidebarContentWatchingCenterComponent;

    constructor(private taskService: TaskService) {
    }

    setMenuActive(activeMenuSelector) {
        this.activeMenu = activeMenuSelector;
    }

    calculateClasses(activeMenuSelector) {
        return {
            btn: true,
            'btn-primary': true,
        };
    }

    ngOnInit(): void {

        try {
            const response = this.getTasksForValidation();
        } catch (e) {
            console.log('Error', e)

        }


    }

    totalTasksForValidationHandler(data) {
        this.totalTasksForValidation = data;
    }

    ngAfterViewInit(): void {

    }

    getTasksForValidation() {
        return new Promise((reslove, reject) => {
            try {
                const response = this.taskService.getTasksForValidation().subscribe(result => {
                    if (result.type === 'success') {
                        this.totalTasksForValidation = result.data.length;
                        reslove();
                    }
                });
            } catch (e) {
                reject(e);
            }
        });


    }


}
